import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operator", "singleValue", "rangeValue", "singleInput", "rangeInput"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isRange = this.operatorTarget.value === "within"

    this.singleValueTarget.classList.toggle("hidden", isRange)
    this.rangeValueTarget.classList.toggle("hidden", !isRange)

    this.singleInputTarget.disabled = isRange
    this.rangeInputTargets.forEach(input => input.disabled = !isRange)
  }
}
